document.addEventListener('DOMContentLoaded', function() {
  if (window.matchMedia("(max-width: 749px)").matches) {
    const accordionHeaders = document.querySelectorAll('.footer .footer-block__heading');

    accordionHeaders.forEach(header => {
      const content = header.nextElementSibling;
      if (content && content.classList.contains('footer-block__details-content')) {
        
        header.addEventListener('click', (event) => {
          event.preventDefault();

          // Sprawdź, czy kliknięty akordeon jest już otwarty
          const isAlreadyOpen = header.classList.contains('active');

          // Najpierw zamknij wszystkie inne akordeony
          accordionHeaders.forEach(otherHeader => {
            otherHeader.classList.remove('active');
            const otherContent = otherHeader.nextElementSibling;
            if (otherContent && otherContent.classList.contains('footer-block__details-content')) {
              otherContent.classList.remove('open');
            }
          });

          // Jeśli kliknięty nie był otwarty, otwórz go
          if (!isAlreadyOpen) {
            header.classList.add('active');
            content.classList.add('open');
          }
        });
      }
    });
  }
});

/* --- Logika zamykania akordeonów na stronie głównej --- */
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.custom-accordion-grid__mobile-item');

  accordions.forEach(accordion => {
    // Używamy eventu 'toggle', który jest specyficzny dla elementu <details>
    accordion.addEventListener('toggle', event => {
      // Jeśli ten akordeon został właśnie otwarty...
      if (accordion.open) {
        // ...to przejdź przez wszystkie pozostałe i je zamknij.
        accordions.forEach(otherAccordion => {
          if (otherAccordion !== accordion) {
            otherAccordion.open = false;
          }
        });
      }
    });
  });
});